export default __webpack_public_path__ + "static/media/zoom-saturday.57a26eff.jpeg";